import React from "react";
import { Link } from "react-router-dom";
import logo from "./images/Beskar-logo.png";

export default function Header() {
  return (
    <header className="flex flex-row justify-between items-center w-full p-4 border-b border-neutral-300">
      <div className="mb-0 flex justify-center w-auto">
        <Link to="/" aria-label="Go to home" className="flex justify-center">
          <img
            src={logo}
            alt="BeskaOne logo"
            className="w-1/3 sm:w-1/4 h-auto cursor-pointer"
            style={{ display: "inline", verticalAlign: "middle" }}
          />
        </Link>
      </div>
      <nav className="hidden sm:flex space-x-4">
        <Link
          to="/login"
          className="px-4 py-2 rounded-xl bg-zinc-50 text-black font-medium hover:bg-zinc-200 transition border border-neutral-300 hover:border-neutral-400"
        >
          Log In
        </Link>
        <Link
          to="/signup"
          className="px-4 py-2 rounded-xl bg-sky-300 text-black font-medium hover:bg-sky-400 transition border border-sky-700 hover:border-sky-800"
        >
          Sign Up
        </Link>
      </nav>
    </header>
  );
}
